import { render } from "./Asset.vue?vue&type=template&id=16560f42&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=js"
export * from "./Asset.vue?vue&type=script&lang=js"

import "./Asset.vue?vue&type=style&index=0&id=16560f42&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16560f42"]])

export default __exports__